import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const MultiUsersKeys = new Set([
  'broadcasts.owner_id',
  'workflows.owner_id',
  'keywords.owner_id',
  'campaigns.user_id',
  'conversations.user_id',
])

export const isMultiUsersWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  MultiUsersKeys.has(filterItem.key)
